export const REQUEST_SIGN_IN = 'REQUEST_SIGN_IN'
export const SIGN_IN = 'SIGN_IN'
export const SUCCESS_SIGN_IN = 'SUCCESS_SIGN_IN'
export const INIT_SUCCESS_SIGN_IN = 'INIT_SUCCESS_SIGN_IN'
export const FAILURE_SIGN_IN = 'FAILURE_SIGN_IN'
export const REQUEST_SIGN_OUT = 'REQUEST_SIGN_OUT'
export const SUCCESS_SING_OUT = 'SUCCESS_SING_OUT'
export const SIGN_OUT = 'SIGN_OUT'
export const FAILURE_SIGN_OUT = 'FAILURE_SIGN_OUT'
export const TURN_ON_ADMIN = 'TURN_ON_ADMIN'

export const CLOSE_AUTH_MODAL = 'CLOSE_AUTH_MODAL'
export const OPEN_AUTH_MODAL = 'OPEN_AUTH_MODAL'



// WEBPACK FOOTER //
// ./src/core/auth/constants.js